<template>
    <div>
        <HirePlan :points="points" :range="range" />
    </div>
</template>

<script>
import HirePlan from "../components/HirePlan";

export default {
    props: ["range", "points"],
    components: {
        HirePlan
    }
};
</script>

<style lang="scss" scoped>
@import "../styles/style";
</style>
